export default {
    "profile": "Profiel",
    "logout": "Uitloggen",
    "dashboard": "Dashboard",
    "password": "Wachtwoord",
    "language": "Taal",
    "paymentbr": "Betaling",
    "subscriptionPaymentMethod": "Abonnement en betalingsmethode",
    "nothingchanged": "Er is niets veranderd",
    "somethingWentWrong": "Er is iets fout gegaan ! Probeer het later opnieuw",
    "pleaseTryAgainAfterSometime": "Probeer het na enige tijd opnieuw",
    "noChanges": "Niet veranderd",
    "invalidEmailFormat": "Het e-mailformaat is ongeldig",
    "chooseYourPreferredLanguage": "Kies uw voorkeurstaal.",
    "selectLanguage": "Selecteer Taal",
    "update": "Update",
    "languagePreferences": "Taalvoorkeuren",
    "packageOf": "Pakket Van",
    "satelliteReport": "satellietrapporten",
    "pastureReport": "weiderapporten",
    "upTo": "Tot",
    "animals": "dieren",
    "back": "Rug",
    "perMonth": "Per maand",
    "perYear": "Per jaar",
    "continue": "Doorgaan",
    "changePlan": "Plan wijzigen",
    "addOn": "Toevoegen",
    "totalPrice": "Totale prijs",
    "availableAddOns": "Beschikbare add-ons",
    "next": "Volgende",
    "congratulations": "Gefeliciteerd",
    "done": "KLAAR",
    "deforestationComplianceAssessment": "Nalevingsbeoordelingen van ontbossing",
    "warning": "Waarschuwing",
    "yourDataMightLost": "Uw gegevens kunnen verloren gaan.",
    "clickOnSaveBtnMsg": "Klik op de knop Opslaan om uw gegevens te bewaren",
    "discardChanges": "Veranderingen ongedaan maken",
    "action": "Acties",
    "sendRequest": "Verzend verzoek",
    "success": "Succes",
    "yourRequestSuccessfullySubmitted": "Uw aanvraag is succesvol verzonden.",
    "informShortly": "Uw aanvraag is succesvol ingediend. Uw analyserapport wordt binnenkort naar u verzonden.",
    "search": "Zoekopdracht",
    "pending": "In behandeling",
    "approved": "Goedgekeurd",
    "rejected": "Afgewezen",
    "primaryGeofence": "Primaire geofence",
    "Zero/Negligible Deforestation Probability": "Nul/Verwaarloosbare Ontbossingskans",
    "Low Deforestation Probability": "Lage Ontbossingskans",
    "High Deforestation Probability": "Hoge Ontbossingskans",
    
    "login": {
        "welcome": "Welkom! Log in",
        "welInfo": "Voer uw inloggegevens in.",
        "login": "Log in",
        "emailMobile": "E-mail/mobiel",
        "forgotPassword": "Wachtwoord vergeten",
        "register": "Register",
        "unableToLogin": "Niet mogelijk om in te loggen",
        "emailMobileCannotEmpty": "E-mail/Mobiel mag niet leeg zijn.",
        "invalidEmailMobileFormat": "Ongeldig e-mail/mobiel formaat.",
        "passwordCannotEmpty": "Wachtwoord mag niet leeg zijn.",
        "passwordLengthCanlessthan8": "De wachtwoordlengte mag niet korter zijn dan 8 tekens.",
        "email": "E-mail",
        "phone": "Telefoon",
        "or": "OF",
        "alreadyHaveAccount": "Heb al een account",
        "loginNow": "Log nu in",
        "registerOption": "Kies een optie om u aan te melden",
        "signUpWith": "Meld aan met"
    },
    "user": {
        "profileUpdated": "Profiel is succesvol bijgewerkt",
        "profileNotUpdated": "Profiel is niet bijgewerkt",
        "otpSentOnEmail": "OTP is succesvol verzonden!",
        "otpSentSuccessFully": "Uw OTP-code is verzonden",
        "unableToVerifyEmail": "Kan de e-mail niet verifiëren",
        "emailCanNotBeEmpty": "E-mailvelden kunnen niet leeg worden gemaakt",
        "firstName": "Voornaam",
        "lastName": "Achternaam",
        "email": "E-mail",
        "mobile": "Mobiel",
        "currentPassword": "huidig ​​wachtwoord",
        "newPassword": "nieuw paswoord",
        "repeatNewPassword": "Herhaal nieuw wachtwoord",
        "firstNameRequired": "Voornaam is verplicht.",
        "lastNameRequired": "Achternaam is vereist",
        "emailRequired": "E-mail is vereist",
        "onlyAlphabet": "Kan alleen alfabetten bevatten",
        "notMoreThan15Char": "Mag niet langer zijn dan 15 tekens",
        "phoneCannotLessThan8Char": "Telefoon mag niet minder dan 8 tekens bevatten",
        "countryCodeRequire": "Landcode is vereist",
        "changePassword": "Verander wachtwoord",
        "goodIdeaToUsePassword": "Het is een goed idee om een ​​sterk wachtwoord te gebruiken dat u elders niet gebruikt.",
        "enterCurrentPassword": "Vul huidig ​​wachtwoord in",
        "enterNewPassword": "Voer een nieuw wachtwoord in",
        "reEnterPassword": "Geef het wachtwoord opnieuw in",
        "pleaseTypeOldPassword": "Typ een oud wachtwoord.",
        "pleaseTypeNewPassword": "Typ een nieuw wachtwoord.",
        "pleaseTypeConfirmPassword": "Typ het wachtwoord bevestigen.",
        "passwordChangedSuccesFully": "wachtwoord succesvol veranderd",
        "passwordDoesNotMatch": "Wachtwoorden komen niet overeen.",
        "passwordRequired": "Een wachtwoord is verplicht",
        "emailOrPhoneIsRequired": "E-mailadres of telefoonnummer is vereist"
    },
    "subscription": {
        "subscription": "Abonnement",
        "membershipPlan": "Lidmaatschapsplannen",
        "currentMembershipPlan": "Huidig ​​lidmaatschapsplan",
        "validUpTo": "Geldig tot",
        "viewAllAddOns": "BEKIJK ALLE EXTRA'S",
        "renewValidity": "Vernieuw de geldigheid",
        "buyNow": "Koop nu",
        "upgradeMembershipPlan": "Upgrade lidmaatschapsplan",
        "chooseYourMembershipPlan": "Uw gekozen lidmaatschapsplan",
        "chooseOptionalAddOns": "U kunt optionele add-ons kiezen",
        "yourSelectedAddons": "Uw geselecteerde add-ons",
        "addAnotherAddOn": "Voeg nog een add-on toe",
        "paymentMethod": "Betalingsmiddel",
        "addingAPaymentMethod": "Een betaalmethode toevoegen",
        "paymentSuccessful": "Uw betaling is gelukt!",
        "weHaveEmailed": "We hebben een kopie van uw ontvangstbewijs per e-mail verzonden naar voorbeeld@email.com",
        "paymentAuthorizedSuccessfully": "Betaling geautoriseerd.",
        "paymentSuccessfulPrompt": "Betaling gelukt. Plan geüpgraded.",
        "paymentCancelled": "Betaling geannuleerd. Probeer het opnieuw."
    },
    "registerFarm": "Boerderij registreren",
    "requestDeforestationReport": "Ontbossingsrapport aanvragen",
    "paymentMenu": "Betaling",
    "complianceCertificate": "Naleving certificaat",
    "helpDisk": "Help-schijf",
    "faqs": "Veelgestelde vragen",
    "enquiries": "Vragen",
    "contactUs": "Neem contact met ons op",
    "payment": {
        "basicPlan": "Basisplan",
        "advancePlan": "Voorschotplan",
        "usdPerMonthPlus": "USD per maand plus",
        "perReport": "per rapport",
        "deforestationAnalyticsCertificateDownload": "Ontbossing analytics certificaat downloaden"
    },
    "farm": {
        "selectFarm":"Selecteer Boerderij",
        "farmOwnershipType": "Eigendomstype boerderij",
        "licenceNum": "Licentienummer",
        "viewFarm": "Bekijk boerderij",
        "stateProvince": "Provincie/Staat",
        "postalNumberShouldSimilarToFarm": "Het postnummer van de boerderij is vergelijkbaar met het huisnummer.",
        "videoTutorial": "Video uitleg",
        "clickOnMapMSG": "Klik op de kaart om geofencing te starten",
        "prev": "Vorige",
        "next": "Volgende",
        "dragVertexMsg": "U kunt de hoekpunten ook slepen of verwijderen met de verwijderknop aan de rechterkant. Geofence kan ook worden gewist met behulp van de knop Wissen",
        "farmAddedSuccessfully": "Boerderij succesvol toegevoegd",
        "perimeter": "Omtrek",
        "area": "Gebied",
        "clearGeofence": "Wis geofence",
        "deleteSelectedVertex": "Verwijder het geselecteerde hoekpunt",
        "pleaseStartDrawing": "Begin met het tekenen van geofence op de kaart.",
        "chooseTheDate": "Kies de datum",
        "updateGeofenceForThisFarm": "UPDATE GEOFENCE voor deze boerderij",
        "farmUpdateSuccessfully": "Boerderij succesvol bijgewerkt",
        "farmZone": "Boerderijzones",
        "addNewZones": "Voeg nieuwe zones toe",
        "zoneName": "Zonenaam",
        "addZoneToCreate": "Klik op Zones toevoegen om een ​​zone voor deze boerderij aan te maken.",
        "noZoneCreated": "Er zijn nog geen zones aangemaakt.",
        "searchAndAddPin": "Zoek en voeg een pincode toe",
        "zoneNameWillBeHere": "Zonenaam zal hier staan",
        "editZone": "Zone bewerken",
        "nameOfTheField": "Naam van het veld",
        "zoneDetails": "Zonedetails",
        "addZone": "Zone toevoegen",
        "nameOfTheZone": "Naam van de zone",
        "geofenceIsRequiredToAdd": "Geofence is vereist om een ​​zone toe te voegen. Klik op 'Bewerk boerderij' om Geofence-details aan uw boerderij toe te voegen.",
        "thisFieldApplyHelpText": "Dit veld is alleen op u van toepassing als u lid bent van een coöperatie (Een coöperatie is een autonome vereniging van personen die zich vrijwillig hebben verenigd om aan hun gemeenschappelijke economische, sociale en culturele behoeften en ambities te voldoen via een onderneming die gezamenlijk eigendom is en democratisch wordt gecontroleerd). ALS u lid bent van een coöperatie, geef dan de unieke identificatiecode van die coöperatie op. Dit kan een registratie- of licentienummer zijn dat de coöperatie waarmee u geassocieerd bent op unieke wijze identificeert.",
        "farmRegistrationID": "Boerderijregistratie-ID",
        "farmerName": "Naam boer",
        "farmerRegistrationID": "Boerenregistratie-ID",
        "dateOfRequest": "Datum van verzoek",
        "status": "Toestand",
        "address": "Adres",
        "save": "Redden",
        "farmAddress": "Adres boerderijlocatie",
        "corporateName": "Bedrijfsnaam",
        "corporateMailingAddress": "Zakelijk postadres",
        "farmID": "Boerderij-ID",
        "onTheFarm": "Op de boerderij",
        "userRoles": "Gebruikersrollen",
        "adduser": "Voeg gebruiker toe",
        "addAuser": "Voeg een gebruiker toe",
        "uploadUsers": "Gebruikers uploaden",
        "addNewUser": "Voeg een nieuwe gebruiker toe",
        "selectDept": "Selecteer Afdeling",
        "selectRole": "Selecteer Rol",
        "editUser": "bewerk gebruiker",
        "totalFarms": "Totaal boerderijen",
        "NoAnimalsRegisteredForthisFarm": "Er zijn geen dieren geregistreerd voor deze boerderij",
        "farmsPerPage": "Boerderijen per pagina",
        "regularFarms": "Reguliere boerderijen",
        "farmRegisteredProducts": "Boerderijgeregistreerde producten",
        "searchByFarmNameAndId": "Zoeken op boerderijnaam en -id",
        "loadingProductsPleaseWait": "Producten laden... Een ogenblik geduld",
        "farmName": "Naam boerderij",
        "farmLocation": "Boerderij locatie",
        "productName": "productnaam",
        "stockStatus": "Voorraadstatus",
        "inStock": "Op voorraad",
        "searchByProductName": "Zoek op productnaam",
        "productCategory": "product categorie",
        "products": "Producten",
        "yourLocationIsDisabled": "Je locatie is uitgeschakeld. Zoek uw locatie via de linkermenu's.",
        "close": "Dichtbij",
        "farms": "Boerderijen",
        "zones": "Zones",
        "registerAfarm": "Registreer een boerderij",
        "govtRegistry": "Overheid Register",
        "cooperativeID": "Coöperatie/Unie-ID",
        "cooperativeName": "Naam coöperatie/vakbond",
        "farmType": "Soort boerderij",
        "contractMating": "Contractparing",
        "customization": "Maatwerk",
        "recordsPerpage": "Records per pagina",
        "restoreDefault": "Standaard herstellen",
        "apply": "Toepassen",
        "CommunityName": "Gemeenschaps naam",
        "searchState": "Zoeken op bedrijfs-ID, overheidsregister, coöperatie-ID, bedrijfstype, contractkoppeling",
        "farmOwner": "Eigenaar van de boerderij",
        "govRegistrationNo": "Registratienummer van de overheid",
        "farmInformation": "Boerderijinformatie",
        "ownershipType": "Type eigendom",
        "farmLicenseInformation": "Informatie over landbouwvergunningen",
        "licenseNumber": "Licentienummer",
        "licenseExpiryDate": "Vervaldatum van licentie",
        "regulatorName": "Naam van de regelaar",
        "regulatorRepresentativeName": "Naam van de vertegenwoordiger van de toezichthouder",
        "farmLocationSize": "Locatie en grootte van de boerderij",
        "productionSystem": "Landbouwsysteem",
        "country": "Land",
        "state": "Staat",
        "city": "Dorp/stad/stad",
        "farmNumber": "Boerderij nummer",
        "postal": "Postcode",
        "houseNumber": "Huisnummer",
        "farmRegistration": "Boerderijregistratie",
        "cancel": "Annuleren",
        "register": "Register",
        "ok": "OK",
        "totalFarmSize": "Totale bedrijfsomvang",
        "geographicLocation": "Geografische locatie",
        "farmGeographicLocation": "Geografische locatie van boerderij",
        "perimeterPointLongitude": "Omtrekpunt Lengtegraad",
        "perimeterPointLatitude": "Omtrekpunt Breedtegraad",
        "perimeterPointLabel": "Perimeterpuntlabel",
        "perimeterLength": "Omtreklengte",
        "farmLatitude": "Breedtegraad van de boerderij",
        "farmLongitude": "Lengtegraad van de boerderij",
        "latitude": "Breedtegraad",
        "longitude": "Lengtegraad",
        "areaUnit": "Gebiedseenheid",
        "walkAndMeasure": "LOPEN EN METEN",
        "useGeofenceTool": "GEBRUIK GEOFENCE-TOOL",
        "editFarm": "Boerderij bewerken",
        "update": "Update",
        "editAfarm": "Bewerk een boerderij",
        "nextFarm": "Volgende boerderij",
        "nameoftheFarm": "Naam van de boerderij",
        "registerAProduct": " Registreer een product",
        "farmProducts": "Landbouwproducten",
        "calf": "Kalf",
        "steer": "Sturen",
        "heifer": "Vaars",
        "sire": "Vader",
        "dam": "Dam",
        "registerAnAnimal": "Registreer een dier",
        "farmAnimals": "Boerderijdieren",
        "farm_type": "Boerderij-type",
        "farm_Owner": "Boerderij-eigenaar",
        "dateOfRegistration": "Registratie datum",
        "dataIsNotAvailableForThisFarm": "Er zijn geen gegevens beschikbaar voor dit bedrijf",
        "registerNewProduct": "Registreer een nieuw product",
        "information": "Informatie",
        "licenseInfo": "Licentie-informatie",
        "locationInfo": "Locatie-informatie",
        "geoLocation": "Geo-locatie",
        "perimeterLengthState": "Lengte van de omtrek van de boerderij (lengte van het hek)",
        "totalFarmSizeState": "Grootte van een boerderij",
        "productionSystemState": "Productiesysteem dat op de boerderij wordt gebruikt",
        "contractMatingState": "Contractcode Paringprogramma waaraan het bedrijf deelneemt.",
        "ownershipTypeState": "Type eigendom",
        "regulatorRepresentativeNameState": "Naam van de persoon die de toezichthouder vertegenwoordigt en die de vergunning heeft afgegeven",
        "regulatorNameState": "Naam van de toezichthouder die de vergunning heeft afgegeven",
        "licenseExpiryDateState": "Datum waarop de huidige licentie is verlopen",
        "licenseNumberState": "Licentienummer vrijgegeven door de toezichthouder",
        "plotNumberState": "Huisnummer van de boerderij.",
        "plotNumber": "Boerderij nummer",
        "streetStatement": "Straatnaam van de boerderij.",
        "cityStatement": "Stad waar de boerderij zich bevindt.",
        "stateStatement": "Regio van het land waar de boerderij zich bevindt.",
        "countryState": "Land waar de boerderij zich bevindt.",
        "farmStateInfo": "Adres boerderijlocatie",
        "perimeterPointLongitudeState": "Lengtegraad van één punt op de boerderij.",
        "perimeterPointLatitudeState": "Breedtegraad van één punt op de boerderij.",
        "perimeterPointLabelState": "Etiket van punt.",
        "farmLongitudeState": "Lengtegraad van de boerderij.",
        "farmLatitudeState": "Breedtegraad van de boerderij.",
        "deleteFarm": "Boerderij verwijderen",
        "corporateRegistrationNum": "Bedrijfsregistratienummer",
        "farmLocationIsRequired": "Boerderijlocatie is vereist."
    },
    "deforestation": {
        "addZoneToThisFarm": "Voeg zones toe aan deze boerderij",
        "copy":'Kopiëren',
        "shareQRCode":'Deel QR-code',
        "registerFarm":"Geregistreerde boerderij",
        "nonRegisterFarm":"Niet-geregistreerde boerderij",
        "chooseRegistrationType":"Kies Registratietype",
        "doYouwantToregisterSingleFarm":"Wilt u één dier of een groep dieren aanmelden?",

        "eudrForestAssessment": "EUDR-bosbeoordelingen",
        "requestEudrForestAssessment": "VERZOEK EUDR-BOSBEOORDELING",
        "pleaseChooseOption": "Kies een optie",
        "requestForestReport": "Bosrapport aanvragen",
        "noDeforestationReportMsg": "Er zijn geen ontbossingsrapporten opgevraagd. Vraag alstublieft enkele ontbossingsrapporten aan om ze hier te laten vermelden.",
        "allCountries": "Alle landen",
        "allRegions": "Alle regio's",
        "allFarms": "Alle boerderijen",
        "allStatus": "Alle status",
        "viewCertificate": "Bekijk certificaat",
        "requestComplianceCertificate": "VRAAG NALEVINGSCERTIFICAAT AAN",
        "assessmentNo": "Beoordeling nr",
        "blockchainCertificationInfo": "Blockchain-certificaatvalidatie-hash zal beschikbaar zijn na acceptatie van het certificaat",
        "blockchainCertificationValidation": "Validatie van Blockchain-certificaten",
        "openBlockchainPage": "Open Blockchain-pagina",
        "clickOnAboveLink": "Klik op bovenstaande link om het certificaat op blockchain te valideren",
        "shareCertificate": "Aandeelbewijs",
        "high": "Hoog",
        "low": "Laag",
        "zeroOrNegigible": "Nul of verwaarloosbaar",
        "deforestationProbability": "Ontbossing Waarschijnlijkheid",
        "colorCode": "Kleurcode",
        "geofenceAarea": "Geofence-gebied",
        "percentageOfGeofenceArea": "Percentage geofence-gebied",
        "overallDeforestationProbability": "Algemene waarschijnlijkheid van ontbossing",
        "deforestationComplianceReport": "Nalevingsrapporten over ontbossing",
        "noDeforestationComplianceReport": "Er is geen e-rapport gevonden dat voldoet aan de eisen voor ontbossing",
        "loadingDeforestationComplianceReport": "E-rapport over ontbossing-compliance laden",
        "farmRegistrationId": "Boerderijregistratie-ID",
        "farmerName": "Naam boer",
        "farmerRegistrationId": "Boerenregistratie-ID",
        "uniqueFarmerId": "Unieke boer-ID",
        "uniqueFarmId": "Unieke boerderij-ID",
        "farmLocation": "Boerderij locatie",
        "area": "Gebied",
        "farmAddress": "Adres boerderij",
        "dateOfRequest": "Datum van verzoek",
        "status": "Toestand",
        "settings": "Instellingen",
        "assignmentIssued": "Opdracht uitgegeven",
        "certificateIssued": "Certificaat afgegeven",
        "complianceCertification": "Nalevingscertificering",
        "noComplianceCertification": "Geen conformiteitscertificering gevonden",
        "loadingComplianceCertification": "Conformiteitscertificering laden",
        "assessmentReport": "Beoordelingsverslag",
        "downloadPDF": "Download PDF",
        "print": "Afdrukken",
        "back": "Rug",
        "farmDetails": "Boerderijdetails",
        "dimitraFarmId": "Dimitra boerderij-id",
        "dimitraFermerId": "Dimitra Boer Id",
        "totalGeofenceAreaHA": "Totaal Geofence-gebied (HA)",
        "forestLossHA": "Bosverlies (HA)",
        "forestGainHA": "Boswinst (HA)",
        "forestUnchangedHA": "Bos ongewijzigd (HA)",
        "forestUnchanged": "Bos Onveranderd",
        "forestLoss": "Bosverlies",
        "forestGain": "Bos winst",
        "totalGeofenceArea": "Totaal Geofence-gebied",
        "forestAssessmentHelp": "Als u vragen heeft over dit rapport of hulp nodig heeft bij het begrijpen ervan, kunt u contact met ons opnemen via de Helpdesk.",
        "allReport": "Alle rapporten",
        "deforestationRepot": "Ontbossingrapporten",
        "requestDeforestationReportNow": "VRAAG NU EEN ONTBOSSAPPORT AAN",
        "noRecordFound": "Geen record gevonden",
        "noDeforestationReportRequested": "Er zijn geen ontbossingsrapporten opgevraagd. Vraag alstublieft enkele ontbossingsrapporten aan om ze hier te laten vermelden.",
        "deforestationImage": "Ontbossing afbeelding",
        "reqDeforestationReport": "Ontbossingsrapport aanvragen",
        "confirm": "Bevestigen",
        "newForestArea": "Nieuw bosgebied",
        "deforestedArea": "Ontbost gebied",
        "existingForestArea": "Bestaand bosgebied",
        "deforestation": "Ontbossing",
        "farmName": "Naam boerderij",
        "location": "Plaats",
        "dateOfInterest": "Datum van interesse",
        "geofenceArea": "GeofenceArea (HA)",
        "deforestationArea": "Ontbossingsgebied (HA)",
        "treeGainArea": "Boomversterkingsgebied (HA)",
        "currentForestArea": "Huidig ​​bosgebied (HA)",
        "view": "Weergave",
        "locationInfoRequired": "Locatie-informatie is vereist",
        "geofenceNameRequired": "Geofence-naam is vereist",
        "futureDateSelected": "Toekomstige datum geselecteerd",
        "reportGeneratedSuccessfully": "Rapport gegenereerd",
        "reportCannotAdded": "Rapport kan niet worden toegevoegd.",
        "primaryFarmNotFound": "Primaire boerderij niet gevonden.",
        "pleaseRegisterFarmFirst": "Registreer eerst de boerderij"
    },
    "certificate": {
        "allCertificate": "Alle certificaten",
        "certificate": "Certificaat"
    }
}